function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import addClass from 'dom-helpers/addClass';
import css from 'dom-helpers/css';
import qsa from 'dom-helpers/querySelectorAll';
import removeClass from 'dom-helpers/removeClass';
import ModalManager from '@restart/ui/ModalManager';
var Selector = {
  FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
  STICKY_CONTENT: '.sticky-top',
  NAVBAR_TOGGLER: '.navbar-toggler'
};

var BootstrapModalManager = /*#__PURE__*/function (_ModalManager) {
  _inherits(BootstrapModalManager, _ModalManager);

  var _super = _createSuper(BootstrapModalManager);

  function BootstrapModalManager() {
    _classCallCheck(this, BootstrapModalManager);

    return _super.apply(this, arguments);
  }

  _createClass(BootstrapModalManager, [{
    key: "adjustAndStore",
    value: function adjustAndStore(prop, element, adjust) {
      var actual = element.style[prop]; // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
      // @ts-ignore

      element.dataset[prop] = actual;
      css(element, _defineProperty({}, prop, "".concat(parseFloat(css(element, prop)) + adjust, "px")));
    }
  }, {
    key: "restore",
    value: function restore(prop, element) {
      var value = element.dataset[prop];

      if (value !== undefined) {
        delete element.dataset[prop];
        css(element, _defineProperty({}, prop, value));
      }
    }
  }, {
    key: "setContainerStyle",
    value: function setContainerStyle(containerState) {
      var _this = this;

      _get(_getPrototypeOf(BootstrapModalManager.prototype), "setContainerStyle", this).call(this, containerState);

      var container = this.getElement();
      addClass(container, 'modal-open');
      if (!containerState.scrollBarWidth) return;
      var paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
      var marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
      qsa(container, Selector.FIXED_CONTENT).forEach(function (el) {
        return _this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth);
      });
      qsa(container, Selector.STICKY_CONTENT).forEach(function (el) {
        return _this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth);
      });
      qsa(container, Selector.NAVBAR_TOGGLER).forEach(function (el) {
        return _this.adjustAndStore(marginProp, el, containerState.scrollBarWidth);
      });
    }
  }, {
    key: "removeContainerStyle",
    value: function removeContainerStyle(containerState) {
      var _this2 = this;

      _get(_getPrototypeOf(BootstrapModalManager.prototype), "removeContainerStyle", this).call(this, containerState);

      var container = this.getElement();
      removeClass(container, 'modal-open');
      var paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
      var marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
      qsa(container, Selector.FIXED_CONTENT).forEach(function (el) {
        return _this2.restore(paddingProp, el);
      });
      qsa(container, Selector.STICKY_CONTENT).forEach(function (el) {
        return _this2.restore(marginProp, el);
      });
      qsa(container, Selector.NAVBAR_TOGGLER).forEach(function (el) {
        return _this2.restore(marginProp, el);
      });
    }
  }]);

  return BootstrapModalManager;
}(ModalManager);

var sharedManager;
export function getSharedManager(options) {
  if (!sharedManager) sharedManager = new BootstrapModalManager(options);
  return sharedManager;
}
export default BootstrapModalManager;